"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatorFullKey = calculatorFullKey;
function calculatorFullKey({ calculatorKey, calculatorGroup }) {
    return calculatorGroup ? `${calculatorGroup}/${calculatorKey}` : calculatorKey;
}
